import { Singleton } from "../di/index.js";
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : null === desc ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
class ModalSurfaceService {
    ensure(options) {
        const appendTo = options.appendTo || document.body;
        let root = document.getElementById(options.id);
        if (!root) {
            root = document.createElement('div');
            root.id = options.id;
            appendTo.appendChild(root);
        }
        root.className = options.modalClassName || 'boost-sd__modal';
        root.setAttribute('aria-modal', 'true');
        root.setAttribute('role', 'dialog');
        root.setAttribute('aria-label', options.ariaLabel || 'modal');
        root.style.display = root.style.display || 'none';
        const backdrop = this.ensureChild(root, '.boost-sd__modal-backdrop', 'div');
        backdrop.className = options.backdropClassName || 'boost-sd__modal-backdrop';
        const container = this.ensureChild(root, '.boost-sd__modal-container', 'div');
        container.className = options.containerClassName || 'boost-sd__modal-container';
        if (options.maxWidth) container.style.maxWidth = options.maxWidth;
        const wrapper = this.ensureChild(container, '.boost-sd__modal-wrapper', 'div');
        wrapper.className = options.wrapperClassName || 'boost-sd__modal-wrapper';
        wrapper.setAttribute('tabindex', '-1');
        return {
            root,
            backdrop,
            container,
            wrapper
        };
    }
    moveToParent(surface, parent, options = {}) {
        const resolvedSurface = this.resolveSurface(surface);
        const { anchor = null, position = 'beforeend' } = options;
        if (anchor && 'insertAdjacentElement' in anchor) return void anchor.insertAdjacentElement(position, resolvedSurface.root);
        if (resolvedSurface.root.parentElement !== parent) parent.appendChild(resolvedSurface.root);
    }
    open(surface, options = {}) {
        this.resolveSurface(surface).root.style.display = options.display || 'flex';
    }
    close(surface, options = {}) {
        this.resolveSurface(surface).root.style.display = options.display || 'none';
    }
    ensureChild(root, selector, tagName) {
        const existing = root.querySelector(selector);
        if (existing) return existing;
        const child = document.createElement(tagName);
        root.appendChild(child);
        return child;
    }
    resolveSurface(surface) {
        if ('wrapper' in surface) return surface;
        const root = surface;
        const backdrop = root.querySelector('.boost-sd__modal-backdrop');
        const container = root.querySelector('.boost-sd__modal-container');
        const wrapper = root.querySelector('.boost-sd__modal-wrapper');
        if (!backdrop || !container || !wrapper) throw new Error('[ModalSurfaceService] Invalid modal surface');
        return {
            root,
            backdrop,
            container,
            wrapper
        };
    }
}
ModalSurfaceService = _ts_decorate([
    Singleton()
], ModalSurfaceService);
export { ModalSurfaceService };
